import { dispatch, store } from 'redux/store';
import { slice } from 'common/infrastructure/map/redux';
import { BoundingBox } from '@planitgeo/treeplotter-domain/lib/infrastructure/geo/geo.interface';
import * as ol from 'ol';
import { transformExtent } from 'ol/proj';

const MapRepository = {
  getCurrentMapConfig() {
    const { map: mapStore } = store.getState();
    return mapStore;
  },

  saveCenter(coords: number[]) {
    dispatch(slice.actions.saveCenter(coords));
  },

  saveZoom(zoom: number) {
    dispatch(slice.actions.saveZoom(zoom));
  },

  setColorProperty(property: string) {
    dispatch(slice.actions.setColorProperty(property));
  },

  getColorProperty() {
    const { map: mapStore } = store.getState();
    return mapStore.selectedDisplayProperty;
  },

  setColorAssignment(value: string, color: string) {
    dispatch(slice.actions.setColorAssignment({ value, color }));
  },

  setShapeAssignment(value: string, shapeIndex: number) {
    dispatch(slice.actions.setShapeAssignment({ value, shapeIndex }));
  },

  getColorAssignments() {
    const { map: mapStore } = store.getState();
    return mapStore.colorAssignments;
  },

  getShapeAssignments() {
    const { map: mapStore } = store.getState();
    return mapStore.shapeAssignments;
  },

  clearAssignments() {
    dispatch(slice.actions.clearAssignments());
  },

  setInitialBoundingBox(boundingBox: BoundingBox | null) {
    dispatch(slice.actions.setInitialBoundingBox(boundingBox));
  },

  getInitialBoundingBox(): BoundingBox | null {
    const { map: mapStore } = store.getState();
    return mapStore.initialBoundingBox;
  },

  clearInitialBoundingBox() {
    dispatch(slice.actions.clearinitialBoundingBox());
  },

  /**
   * Fits the map view to the given bounding box
   * @param map - OpenLayers map instance
   * @param boundingBox - Bounding box coordinates
   */
  fitToBoundingBox(map: ol.Map | null, boundingBox: BoundingBox) {
    if (!map || !boundingBox) {
      return;
    }

    const extent = [boundingBox.minLng, boundingBox.minLat, boundingBox.maxLng, boundingBox.maxLat];

    // Transform extent from WGS84 to Web Mercator (EPSG:3857)
    const transformedExtent = transformExtent(extent, 'EPSG:4326', 'EPSG:3857');

    // Fit the map view to the extent with some padding
    map.getView().fit(transformedExtent, {
      padding: [50, 50, 50, 50],
      duration: 1000, // Smooth animation
    });
  },
};

export { MapRepository as default };
